export default {
    money(value) {
        return "£" + Number(value || 0).toFixed(2).replace(/[.,]00$/, "");
    },
    shortDate(value) {
        if (!value) return null;

        const date = new Date(value);
        const day = date.getDate();
        const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        const month = monthNames[date.getMonth()];
        const year = date.getFullYear();

        const suffix = day === 1 || day === 21 || day === 31 ? 'st' :
                       day === 2 || day === 22 ? 'nd' :
                       day === 3 || day === 23 ? 'rd' : 'th';

        return `${day}${suffix} ${month} ${year}`;
    }
}
